import { Middleware } from "@reduxjs/toolkit";
import { setIndexDBValue } from "@frontend/utils/indexDBCaching";
import { paramsToKey } from "./utils";
import { setWeatherData } from "./weatherSlice";

export const weatherPersistenceMiddleware: Middleware =
  (_store) => (next) => (action) => {
    if (setWeatherData.match(action)) {
      const key = paramsToKey("daily", action.payload);
      setIndexDBValue(key, action.payload);
    }
    return next(action);
  };
